export default __webpack_public_path__ + "static/media/img2.43b00c04.jpg";